// extracted by mini-css-extract-plugin
export default {"globalPageWrapper":"PageWrapper_globalPageWrapper__c3o0I"};